import Blockly from 'blockly';

import Params from '../parammanager';

Blockly.Blocks['command_definition'] = {
  init: function () {
    this.appendDummyInput('command_name')
      .appendField('Command: !')
      .appendField(
        new Blockly.FieldTextInput(
          'command_name',
          this.validateCommandName
        ),
        'Name'
      )
      .appendField(
        Params.toSyntax(),
        'Syntax'
      );

    this.appendDummyInput('description')
      .appendField('Description:')
      .appendField(
        new Blockly.FieldTextInput(
          'Command Description',
        ),
        'Description'
      )
      .setAlign(Blockly.ALIGN_LEFT);

    this.appendStatementInput('Content')
      .setCheck(null);

    this.setInputsInline(false);
    this.setColour('#808080');
    this.setTooltip('Define your command here. Commands must be all lower case, no spaces, no punctuation.');
    this.setHelpUrl("");

    this.setMovable(false);
    this.setDeletable(false);
  },
  validateCommandName: function(value) {
    let re = new RegExp('^[a-zA-Z0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF-_]+$');
    if (!re.test(value)) {
      return null;
    }
  }
};

Blockly.JSON['command_definition'] = function (block) {
  const text_name = block.getFieldValue('Name');
  const description = block.getFieldValue('Description');
  let actions = Blockly.JSON.statementToCode(block, 'Content');

  actions = actions.filter((item) => {
    return item != null;
  });

  const params = Params.getParams();
  const filtered = params.map(({blockId, ...keepAttrs}) => keepAttrs)

  return {
    command: text_name,
    params: filtered,
    description: description,
    actions: actions || []
  }
};

Blockly.Blocks['default_activate'] = {
  init: function() {
    this.appendDummyInput('Input')
      .appendField('Players current active item.')
    this.setOutput(true, ['Collectible'])
  }
}

Blockly.JSON['default_activate'] = (block) => {
  return {
    entity_id: -1
  }
}


Blockly.Blocks['define_param'] = {
  init: function () {
    let name = Params.getNextParamName();

    this.appendDummyInput('define_param')
      .appendField('Expect the')
      .appendField(
        new Blockly.FieldDropdown(Params.types),
        'Position'
      )
      .appendField('to be')
      .appendField(
        new Blockly.FieldDropdown([
          ['a number', 'number'],
          ['a string', 'string'],
          ['an Active Item', 'active'],
          ['a Boss', 'boss'],
          ['a Card', 'card'],
          ['a Character', 'character'],
          ['a Collectible (active and passive)', 'collectible'],
          ['a Costume', 'costume'],
          ['a Curse', 'curse'],
          ['an Enemy (bosses and monsters)', 'enemy'],
          ['a Friend (bosses and monsters)', 'friend'],
          ['a Givable (cards, collectibles, pills, and trinkets)', 'givable'],
          ['a Monster', 'monster'],
          ['a Passive Item', 'passive'],
          ['a Pill', 'pill'],
          ['a Room', 'room'],
          ['a Spawnable (cards, collectibles, enemies, pills, and trinkets)', 'spawnable'],
          ['a Stat', 'stat'],
          ['a Takable (collectibles, and trinkets)', 'takable'],
          ['a Trinket', 'trinket'],
          ['a Poop Spell', 'poopspell'],
        ]),
        'Type'
      )
      .appendField('named')
      .appendField(
        new Blockly.FieldTextInput(
          name
        ),
        'Name'
      );
    this.setInputsInline(false);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Define a parameter type.');
    this.setHelpUrl('');
  },
  onchange: function(event) {
    Params.updateParams();
    if (event.type === Blockly.Events.CHANGE && event.name === 'Name') {

      let workspace = undefined;
      const workspaces = Blockly.Workspace.getAll();
      for (let ws in workspaces) {
        if (workspaces[ws].isVisible()) {
          workspace = workspaces[ws];
        }
      }
      if (!workspace) {
        //console.log("no workspace, returning")
        return;
      }

      const children = workspace.getBlocksByType('param_get');
      if (!children) {
        //console.log("no children, returning")
        return;
      }

      for (let child in children) {
        let param = children[child].getField('Param');
        let blockId = param.getValue();
        let name = param.getText();

        if (name === event.oldValue) {
          children[child].getField('Param').setValue(null);
          children[child].getField('Param').selectedOption_ = [event.newValue, blockId];
          children[child].getField('Param').forceRerender();
        }
      }
    }
  }
};

Blockly.JSON['define_param'] = (block) => {
  return
};

/******** */

Blockly.Blocks['param_get'] = {
  init: function() {
    let source = Params.getParams();
    let params = source.map((param) => {
      return [ param.name, param.blockId ]
    });

    if (params.length === 0) {
      this.dispose(true);
      return
    };

    let dropdown = new Blockly.FieldDropdown(params)
    dropdown.menuGenerator_ = function() {
      return Params.getParams().map((param) => {
        return [ param.name, param.blockId ]
      });
    };

    this.appendDummyInput()
      .appendField('input from command parameter')
      .appendField(dropdown, 'Param');
    let blockId = this.getFieldValue('Param');
    try {
      let param = Params.getTypeByBlockId(blockId);
      this.setOutput(true, [param]);
    } catch {
      this.setOutput(true, [
        "number",
        "string",
        "active",
        "boss",
        "card",
        "character",
        "collectible",
        "costume",
        "curse",
        "enemy",
        "friend",
        "givable",
        "monster",
        "passive",
        "pill",
        "room",
        "spawnable",
        "stat",
        "takable",
        "trinket",
        "poopspell",
      ]);
    }
  },
  onchange: function() {
    let blockId = this.getFieldValue('Param');
    try {
      let param = Params.getTypeByBlockId(blockId);
      this.setOutput(true, [param])
    } catch(err) {
      console.log(err)
    }
  }
}

Blockly.JSON['param_get'] = (block) => {
  let name = block.getField('Param').getText();
  return {
    from_param: name,
  }
}
